import { render, staticRenderFns } from "./LogoPortal.vue?vue&type=template&id=72ff3aa2&lang=pug"
import script from "./LogoPortal.vue?vue&type=script&lang=ts"
export * from "./LogoPortal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports